import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { graphql } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import { Form, Row, Col, Button, Tag, message } from 'antd'
import moment from 'moment'
import _get from 'lodash/get'
import _sortBy from 'lodash/sortBy'
// import queryString from 'query-string'

import { injectIntl, FormattedMessage } from 'react-intl'

import RegistrationSteps from '~/App/components/RegistrationSteps'
import registrationQuery from '~/App/graphql/queries/registration.gql'
import submitRegistrationMutation from '~/App/graphql/mutations/submitRegistration'
import getAgeCategory from '~/App/utils/getAgeCategory'

// const getAgeCategory = ({
//   race: { startTime, ageCategories, ageCategoryDiff },
//   birthDate,
//   gender
// }) => {
//   // TODO: important use race
//   const $birthDate = moment(birthDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
//   const {
//     month, date, hour, minute, second, millisecond
//   } = $birthDate.toObject()
//   let $startTime = moment(startTime).set({
//     month, date, hour, minute, second, millisecond
//   })
//   if (ageCategoryDiff === 'day') {
//     $startTime = moment(startTime).set({
//       hour, minute, second, millisecond
//     })
//   }
//   const fullAge = $startTime.diff($birthDate, 'year') // moment(startTime).year() - moment(birthDate).year()
//   return {
//     category: ageCategories.filter(cat => cat.gender === gender).find(cat => {
//       return (
//         (!cat.min && cat.max >= fullAge) ||
//         (!cat.max && cat.min <= fullAge) ||
//         (cat.min <= fullAge && cat.max >= fullAge)
//       )
//     }),
//     gender
//   }
// }
const taxInvoiceOptions = [{
  _id: 'none',
  en: 'None',
  th: 'ไม่ขอใบกำกับภาษี'
}, {
  _id: 'individual',
  en: 'Individual',
  th: 'บุคคล'
}, {
  _id: 'company',
  en: 'Company',
  th: 'บริษัท'
}]

const bibNumber = number => {
  const pad = '0000'
  return pad.substr(0, pad.length - `${number}`.length) + number
}

@graphql(registrationQuery, {
  options: ({ match: { params: { id } } }) => ({
    variables: { _id: id },
    fetchPolicy: 'network-only'
  })
})
@graphql(submitRegistrationMutation, {
  name: 'submitRegistration'
})
@inject('i18n')
@injectIntl
@observer
class RegistrationPreview extends Component {
  state = {
    id: '',
    submitting: false
  }

  ageCategoryString = ({ category, gender }) => {
    const g = gender ? gender[0].toUpperCase() : ''
    if (!category) {
      return <FormattedMessage id="app.ageCategories.open" />
    }
    const { min, max } = category
    if (!min && max) {
      return <FormattedMessage id="app.ageCategories.under" values={{ gender: g, upper: max + 1 }} />
      // return `${g} under ${max + 1}`
    } else if (min && !max) {
      return <FormattedMessage id="app.ageCategories.over" values={{ gender: g, lower: min }} />
      // return `${g} ${min} up`
    } else {
      return <FormattedMessage id="app.ageCategories.between" values={{ gender: g, lower: min, upper: max }} />
      // return `${g} ${min} - ${max}`
    }
  }

  handleSubmitRegistration = e => {
    e.preventDefault()
    const { data, intl, submitRegistration, history, match: { params: { id } } } = this.props
    const participants = _get(data, 'registration.participants')
    const registrationType = _get(data, 'registration.registrationType')
    const minParticipants = _get(registrationType, 'minParticipants', 1) || 1
    const maxParticipants = _get(registrationType, 'maxParticipants')
    const restrictions = _get(registrationType, 'restrictions', [])

    // const {
    //   submitRegistration,
    //   history,
    //   match: { params: { id } }
    // } = this.props
    // history.push(`/reg/${id}/preview`)
    // validateFields({ force: true }, (err, record) => {
    // if (!err) {
    if (participants.length < minParticipants) {
      const $message = intl.formatMessage({
        id: 'app.minParticipantsNotice',
        defaultMessage: 'Please add more participant'
      }, {
        min: minParticipants
      })
      history.push(`/reg/${id}/edit?pId=new`)
      return message.warning($message)
    } else if (maxParticipants && participants.length > maxParticipants) {
      const $message = intl.formatMessage({
        id: 'app.maxParticipantsNotice',
        defaultMessage: 'Only {max} participants allowed'
      }, {
        max: maxParticipants
      })
      history.push(`/reg/${id}/edit?pId=new`)
      return message.warning($message)
    } else {
      const genders = participants.map(p => _get(p, 'profile.gender'))
      if (restrictions.includes('gender_mix') &&
        (!genders.includes('male') || !genders.includes('female'))
      ) {
        const $message = intl.formatMessage({
          id: 'app.genderMixError',
          defaultMessage: 'Group should contain both male and female participants'
        })
        return message.warning($message)
      } else if (restrictions.includes('gender_male') && genders.includes('female')) {
        const $message = intl.formatMessage({
          id: 'app.genderMaleOnlyError',
          defaultMessage: 'Only male participants allowed'
        })
        return message.warning($message)
      } else if (restrictions.includes('gender_female') && genders.includes('male')) {
        const $message = intl.formatMessage({
          id: 'app.genderFemaleOnlyError',
          defaultMessage: 'Only female participants allowed'
        })
        return message.warning($message)
      }
    }
    this.setState({
      submitting: true
    })
    submitRegistration({
      variables: {
        _id: id
      }
    }).then(res => history.push(`/reg/${id}/pay`), err => {
      // console.log({ err })
      const [{ message: $message }] = err.graphQLErrors
      // console.log({ $message })
      message.error($message)
      this.setState({
        submitting: false
      })
    }) // TODO: read from res.record?
    // }
    // })
  }
  componentWillReceiveProps (nextProps) {
    const { data, match: { params: { id } } } = nextProps
    const status = _get(data, 'registration.status')

    // const event = _get(registration, 'event')
    // const expired = _get(registration, 'expired')
    // const periods = _get(event, 'periods', [])
    // // const preRegisterPeriod = _get(event, 'preRegisterPeriod')
    // const currentPeriod = periods.find(period =>
    //   moment().isBetween(period.start, period.end)
    // )
    // const preRegisterOpen = currentPeriod && currentPeriod.preRegister
    if (['paid', 'payment_verifying'].includes(status)) {
      this.props.history.replace(`/reg/${id}`)
    }
  }
  render () {
    // console.log('render')
    const { data, match: { params: { id } }, i18n: { locale } } = this.props
    const eventProducts = _get(data, 'registration.eventProducts', [])
    const { registration, loading } = data
    // const { l: locale = 'en' } = queryString.parse(search)
    // console.log(locale)
    if (loading) {
      return <div>Loading...</div>
    }
    if (!registration) {
      return <div>Registration not found</div>
    }
    const {
      _id,
      expireAt,
      expired,
      event,
      participants,
      amount,
      status,
      code,
      registrationType,
      couponCodes
    } = registration
    const hideNumber = _get(event, 'settings.ticket.hideNumber')
    const systemFee = _get(event, 'settings.registration.fee', 0)

    const minParticipants = _get(registrationType, 'minParticipants', 1) || 1
    const maxParticipants = _get(registrationType, 'maxParticipants')
    const regIncomplete = (participants.length < minParticipants || participants.length > maxParticipants)
    const $regIncompleteNotice = <div>
      <FormattedMessage id="app.notice.incompleteReg" defaultMessage="Registration incomplete, please edit and add participants" />
    </div>

    // successfulPayment
    // console.log({ couponCodes })
    const { periods = [], slug, isRegOpen } = event
    const currentPeriod = periods.find(period =>
      moment().isBetween(period.start, period.end) || moment().isBetween(period.preRegisterStart, period.preRegisterEnd)
    )
    // const registerPeriod = periods.find(p => !p.preRegister)
    const isPreRegister = currentPeriod && moment().isBetween(currentPeriod.preRegisterStart, currentPeriod.preRegisterEnd)
    // const canPay = isRegOpen && currentPeriod && !currentPeriod.preRegister
    // const canSubmit = isRegOpen && currentPeriod && !currentPeriod.preRegister // || (preRegisterPeriod && moment().isBetween(preRegisterPeriod.start, preRegisterPeriod.end))
    const ticketsQuota = _get(event, 'ticketsQuota', [])

    const quota = ticketsQuota.find(q => q._id === registrationType.limitId)
    // console.log({ quota })
    const regTypeFull = (!!quota && quota.count >= quota.limit)

    // const $submitButton = (
    //   <Button
    //     type="primary"
    //     size="large"
    //     onClick={() => this.handleSubmit({ registrationId: _id })}
    //     style={{ marginLeft: '18px', float: 'right' }}
    //   >
    //     Submit
    //   </Button>
    // )
    // const $submitDisabledButton = (
    //   <Button
    //     type="primary"
    //     size="large"
    //     disabled
    //     style={{ marginLeft: '18px', float: 'right' }}
    //   >
    //     Submit
    //   </Button>
    // )
    // const $payButton = (
    //   <Link
    //     to={`/reg/${_id}/pay`}
    //     style={{ marginLeft: '18px', float: 'right' }}
    //   >
    //     <Button type="primary" size="large">
    //       PAY
    //     </Button>
    //   </Link>
    // )

    // const $expiredTag = <Tag color="red">Expired</Tag>
    // if (false) {
    //   const $actionButton = {
    //     draft: canSubmit ? $submitButton : $submitDisabledButton,
    //     submitted: canPay && (expired ? $expiredTag : $payButton)
    //   }
    //   console.log($actionButton)
    // }
    const $paymentStatus = ({
      paid: <Tag color="green">{_get(amount, 'discounted')} THB ({
        <FormattedMessage id="paymentStatus.paid" defaultMessage="Paid" />
      })</Tag>,
      payment_verifying: (
        <Tag color="yellow">{_get(amount, 'discounted')} THB ({
          <FormattedMessage id="paymentStatus.verifying" defaultMessage="Pending Verification" />
        })</Tag>
      ),
      '': <Tag color="orange">{_get(amount, 'discounted')} THB ({
        <FormattedMessage id="paymentStatus.pending" defaultMessage="Pending Payment" />
      })</Tag>
    })[status || '']
    const $nextAction = ({
      submitted: <Link to={`/reg/${_id}/pay`}>
        <Button type="primary" disabled={expireAt && expired}><FormattedMessage id="app.pay" defaultMessage="Pay" /></Button>
      </Link>,
      draft: (isRegOpen
        ? (regTypeFull
          ? <Button type="danger">
            <FormattedMessage id="app.regTypeFull" defaultMessage="Registration Type Full" />
          </Button>
          : <Button type="primary" htmlType="submit" loading={this.state.submitting} disabled={regIncomplete}>
            <FormattedMessage id="app.submit" defaultMessage="Submit" />
          </Button>
        )
        : (isPreRegister
          ? <Button disabled>
            <FormattedMessage id="app.submit" defaultMessage="Submit" disabled={regIncomplete} />
          </Button>
          : <Button disabled><FormattedMessage id="app.regClosed" defaultMessage="Registration Closed" /></Button>
        )
      )

    })[status]
    const { discounted, discount, total } = amount
    return <div>
      <Form onSubmit={this.handleSubmitRegistration} style={{ padding: '26px' }} className="EventRegisterPage">
        <div className="eventDetails" style={{ paddingTop: '85px', display: 'flex', justifyContent: ' center' }}>
          <div className="eventTitle">
            {_get(data, ['registration', 'event', 'name', locale])}
          </div>
        </div>
        <div style={{ maxWidth: '1000px', margin: 'auto' }}>
          <RegistrationSteps step="review" />
          <div style={{ padding: '26px', background: 'white', borderRadius: '0 0 8px 8px' }}>
            <div className="simpleBgColor" style={{
              fontSize: 'large',
              textAlign: 'center',
              marginBottom: '1em'
            }}>
              <Link to={`/events/${slug}`} className="modlink">
                {event.name[locale]}
              </Link> - {registrationType.name[locale]}
            </div>
            <Row>
              <Col xs={4}>
                <span>
                  {code
                    ? <span style={{ fontSize: 'large' }}>{{
                      en: 'Reg. No.',
                      th: 'ใบสมัคร'
                    }[locale]}: {code}</span>
                    : <span style={{ fontSize: 'large' }}> [Draft] </span>
                  }
                </span>
              </Col>
              <Col xs={20}>
                <div>
                  Race Day : {moment(event.startDate).format('Do MMMM YYYY')}
                  {' '}
                  {$paymentStatus}
                  {' '}
                  {expireAt &&
                    (expired
                      ? <Tag color="red">
                        <FormattedMessage id="app.expired" defaultMessage="Expired" />
                      </Tag>
                      : <Tag color="orange">
                        <FormattedMessage id="app.payBeforeDate" defaultMessage="Please pay before {date}" values={{
                          date: moment(expireAt).format('Do MMMM HH:mm')
                        }}/>
                      </Tag>
                    )
                  }
                </div>
              </Col>
              {/* <Col xs={2}> {$actionButton[status] }</Col> */}
              <Col xs={24}>
                <div>
                  {participants.map(participant => {
                    const taxInvoiceTypeId = _get(participant, 'profile.taxInvoice.type')
                    const taxInvoiceType = taxInvoiceOptions.find(o => o._id === taxInvoiceTypeId)
                    const emergencyContact = _get(participant, 'profile.emergencyContact')
                    return <Row
                      style={{ borderBottom: '1px dashed gainsboro' }}
                      key={participant._id}
                    >
                      <Col xs={23} sm={11}>
                        <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {
                              {
                                en: 'Name - Surname',
                                th: 'ชื่อ - นามสกุล'
                              }[locale]
                            }
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.firstName}{' '}
                            {participant.profile.lastName}
                          </span>
                        </div>
                        <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Gender', th: 'เพศ' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.gender}
                          </span>
                        </div>
                        <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'BirthDay', th: 'วันเกิด' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {moment(participant.profile.birthDate).format(
                              'D MMMM YYYY'
                            )}
                          </span>
                        </div>
                        <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Email', th: 'อีเมล' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.email}
                          </span>
                        </div>
                        <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Telephone', th: 'โทรศัพท์' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.telephone}
                          </span>
                        </div>
                        {participant.profile.nationality && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Nationality', th: 'สัญชาติ' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.nationality}
                          </span>
                        </div>}
                        {participant.profile.nationalId && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'National ID / Passport ID', th: 'เลขประจำตัวประชาชน' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.nationalId}
                          </span>
                        </div>}
                        {participant.profile.street && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Address', th: 'ที่อยู่' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.street}
                          </span>
                        </div>}
                        {participant.profile.locality && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Locality', th: 'ตำบล/แขวง' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.locality}
                          </span>
                        </div>}
                        {participant.profile.city && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'City', th: 'อำเภอ/เขต' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.city}
                          </span>
                        </div>}
                        {participant.profile.province && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Province of Residence', th: 'จังหวัดที่พักอาศัย' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.province}
                          </span>
                        </div>}
                        {participant.profile.country && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Country of Residence', th: 'ประเทศที่พักอาศัย' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.country}
                          </span>
                        </div>}
                        {taxInvoiceType &&
                          <div>
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Tax Invoice', th: 'ใบกำกับภาษี' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {taxInvoiceType[locale]}
                              </span>
                            </div>
                            {taxInvoiceTypeId !== 'none' && [
                              <div className="eventBottomDetailBox" key="taxId">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Tax ID', th: 'หมายเลขประจำตัวผูเสียภาษี' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {_get(participant, 'profile.taxInvoice.taxId')}
                                </span>
                              </div>,
                              <div className="eventBottomDetailBox" key="address">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Address', th: 'ที่อยู่' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {_get(participant, 'profile.taxInvoice.address')}
                                </span>
                              </div>
                            ]}
                          </div>
                        }
                        {emergencyContact &&
                          <div>
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Emergency Contact', th: 'ผู้ติดต่อกรณีฉุกเฉิน' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {emergencyContact.name}
                              </span>
                            </div>
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Emergency Contact Relationship', th: 'ควาสัมพันธ์ผู้ติดต่อ' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {emergencyContact.relationship}
                              </span>
                            </div>
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Emergency Contact Phone Number', th: 'โทรศัพท์ผู้ติดต่อกรณีฉุกเฉิน' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {emergencyContact.phone}
                              </span>
                            </div>
                          </div>
                        }
                      </Col>
                      <Col xs={23} sm={11}>
                        {participant.tickets.map(ticket => (
                          <div key={ticket._id} >
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {
                                  { en: 'Race', th: 'ประเภทการแข่งขัน' }[locale]
                                }
                              </span>
                              <span className="eventBottomDetailData">
                                {ticket.ticketType.name[locale]}
                              </span>
                            </div>
                            {_get(ticket, 'ticketType.race.ageCategories') && <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Category', th: 'รุ่นอายุ' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {this.ageCategoryString(
                                  getAgeCategory({
                                    race: ticket.ticketType.race,
                                    birthDate:
                                        participant.profile.birthDate,
                                    gender: participant.profile.gender
                                  })
                                )}
                              </span>
                            </div>}
                            {!hideNumber && ticket.number && (
                              <div className="eventBottomDetailBox" >
                                <span className="eventBottomDetailTitle">
                                  {
                                    { en: 'BIB Number', th: 'เลขบิบ' }[locale]
                                  }
                                </span>
                                <span className="eventBottomDetailData">
                                  {bibNumber(ticket.number)}
                                </span>
                              </div>
                            )}
                            {ticket.reservedNumber && (
                              <div>
                                <span className="eventBottomDetailTitle">
                                  {
                                    { en: 'BIB Number (VIP)', th: 'เลขบิบ (VIP)' }[locale]
                                  }
                                </span>
                                <span className="eventBottomDetailData">
                                  {bibNumber(ticket.reservedNumber)}
                                </span>
                              </div>
                            )}
                            {ticket.nameOnBib &&
                              <div>
                                <span className="eventBottomDetailTitle">
                                  {
                                    {
                                      en: 'Name On Bib',
                                      th: 'ชื่อบนเบอร์วิ่ง'
                                    }[locale]
                                  }
                                </span>
                                <span className="eventBottomDetailData">
                                  {ticket.nameOnBib}
                                </span>
                              </div>
                            }
                            {_sortBy(ticket.options, ['question.order']).map(option => {
                              const items = _get(option, 'question.items', [])

                              const optionValue = {
                                Open: option.value,
                                Choice: _get(items.find(i => i._id === option.itemId), ['value', locale], option.itemId),
                                MultiChoice: items.filter(i => option.itemIds.includes(i._id)).map(i => i.value[locale]).join(', ')
                              }[option.question.kind]
                              // console.log({ option })
                              return (
                                <div
                                  key={option._id}
                                  className="eventBottomDetailBox"
                                >
                                  <span className="eventBottomDetailTitle">
                                    {option.question.name[locale]}
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {optionValue}
                                  </span>
                                </div>
                              )
                            })}
                            {event.shirts.length > 0 && ticket.shirtId &&
                            <div key="shirt" className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Shirt', th: 'เสื้อ' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {event.shirtTypes.find(st => st._id === ticket.shirtTypeId).name[locale]}&nbsp;
                                {event.shirts.find(s => s._id === ticket.shirtId).name[locale]}
                              </span>
                            </div>
                            }
                          </div>
                        ))}
                      </Col>
                    </Row>
                  })}
                </div>
              </Col>
            </Row>
            <div>{eventProducts.map(eventProduct => {
              const productType = _get(eventProduct, 'eventProductType')
              return <div key={eventProduct._id}>
                {_get(productType, ['name', locale])} (<FormattedMessage id="app.amountBaht" values={{ amount: productType.price }} />)
                <div>
                  {eventProduct.options.map(option => (
                    <div key={option._id}><span className="eventBottomDetailTitle">{_get(option, ['question', 'name', locale])}</span> <span className="eventBottomDetailData">{option.value || option.itemId || option.itemIds}</span></div>
                  ))}
                </div>
              </div>
            })}
            </div>
            {couponCodes && couponCodes.length > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
              Code: {couponCodes.map(cc => cc.code).join(', ')}
            </div>}
            {discount > 0 && <div style={{ padding: '8px', textAlign: 'right', textDecoration: 'line-through' }}>
              Total: {total} THB
            </div>}
            {systemFee > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
              Fee: +{systemFee} THB
            </div>}
            <div style={{ padding: '8px', textAlign: 'right' }}>
              Total: {discounted} THB
            </div>
            {isPreRegister &&
              <div style={{ padding: '8px', textAlign: 'center' }}>
                {{
                  en: `Please come back to submit the registration on ${moment(_get(currentPeriod, 'start')).format('Do MMMM YYYY hh:mm')}`,
                  th: `กรุณากลับมากดส่งใบสมัครอีกครั้งในวันที่ ${moment(_get(currentPeriod, 'start')).format('Do MMMM YYYY hh:mm')} เป็นต้นไป`
                }[locale]} <Link to="/dashboard" key="done">
                  {{
                    en: 'Done',
                    th: 'เสร็จสิ้น'
                  }[locale]}
                </Link>
              </div>
            }
            {regIncomplete && $regIncompleteNotice}
            <div style={{ padding: '8px', textAlign: 'right' }}>
              <Link to={`/reg/${id}/edit`}>
                <Button type="primary" style={{ marginRight: '8px' }}>
                  <FormattedMessage id="app.edit" defaultMessage="Edit" />
                </Button>
              </Link>
              {$nextAction}
            </div>
          </div>
        </div>
      </Form>
    </div>
  }
}

export default RegistrationPreview



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/RegistrationPreview/RegistrationPreview.js